export default __webpack_public_path__ + "static/media/07_DAIF_SUSTAINABILITY_03_loop.16fb74c8.mp4";